export default function Datenschutz() {
    return (
        <div className="space-y-6">
            <h2 className="text-3xl font-serif">Datenschutz</h2>

            <section className="space-y-2">
                <h3 className="text-lg font-semibold">1. Verantwortlicher</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                    Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:<br />
                    AK Origins, Tegernseer Landstraße 256, 81549 München, Deutschland<br />
                    E-Mail: <a href="mailto:mail@ak-origins.de" className="underline">mail@ak-origins.de</a><br />
                    Website: <a href="https://www.ak-origins.de" className="underline">www.ak-origins.de</a>
                </p>
            </section>

            <section className="space-y-2">
                <h3 className="text-lg font-semibold">2. Allgemeines zur Datenverarbeitung</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                    Wir verarbeiten personenbezogene Daten unserer Nutzer grundsätzlich nur, soweit dies zur Bereitstellung einer funktionsfähigen Website sowie unserer Inhalte und Leistungen erforderlich ist. Die Verarbeitung erfolgt auf Grundlage der einschlägigen datenschutzrechtlichen Bestimmungen, insbesondere der DSGVO.
                </p>
            </section>

            <section className="space-y-2">
                <h3 className="text-lg font-semibold">3. Hosting</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                    Diese Website wird gehostet bei Vercel Inc., 340 Pine Street, Suite 701, San Francisco, CA 94104, USA. Beim Aufruf unserer Website werden automatisch Verbindungsdaten erfasst (IP-Adresse, Datum und Uhrzeit des Zugriffs, aufgerufene Seiten). Diese Daten werden auf den Servern von Vercel verarbeitet. Vercel ist nach den EU-Standardvertragsklauseln zertifiziert.<br /><br />
                    Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse am sicheren Betrieb der Website).
                </p>
            </section>

            <section className="space-y-2">
                <h3 className="text-lg font-semibold">4. Google Fonts</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                    Diese Website verwendet Google Fonts zur einheitlichen Darstellung von Schriftarten. Anbieter ist Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA.<br /><br />
                    Beim Aufruf einer Seite lädt Ihr Browser die benötigten Schriftarten direkt von Google-Servern. Dabei wird Ihre IP-Adresse an Google übertragen. Google Fonts werden ohne Anmeldung oder Cookies eingebunden, jedoch wird Ihre IP-Adresse von Google erfasst und verarbeitet.<br /><br />
                    Weitere Informationen zu Google Fonts:{" "}
                    <a href="https://developers.google.com/fonts/faq" className="underline" target="_blank" rel="noopener noreferrer">
                        developers.google.com/fonts/faq
                    </a><br />
                    Datenschutzerklärung von Google:{" "}
                    <a href="https://policies.google.com/privacy" className="underline" target="_blank" rel="noopener noreferrer">
                        policies.google.com/privacy
                    </a><br /><br />
                    Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer einheitlichen und ansprechenden Darstellung unserer Website).
                </p>
            </section>

            <section className="space-y-2">
                <h3 className="text-lg font-semibold">5. Kontaktformular</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                    Wenn Sie uns über das Kontaktformular auf unserer Website eine Nachricht senden, werden die von Ihnen eingegebenen Daten (z. B. Name, E-Mail-Adresse, Nachricht) bei uns gespeichert, um Ihre Anfrage zu bearbeiten und eventuelle Rückfragen zu beantworten. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.<br /><br />
                    Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung) bzw. Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der Bearbeitung von Anfragen).<br /><br />
                    Die übermittelten Daten werden gelöscht, sobald die Anfrage abschließend bearbeitet wurde und keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
                </p>
            </section>

            <section className="space-y-2">
                <h3 className="text-lg font-semibold">6. Ihre Rechte</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                    Sie haben gegenüber uns folgende Rechte hinsichtlich der Sie betreffenden personenbezogenen Daten:
                </p>
                <ul className="text-sm text-gray-600 leading-relaxed list-disc list-inside space-y-1">
                    <li>Auskunftsrecht (Art. 15 DSGVO)</li>
                    <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
                    <li>Recht auf Löschung (Art. 17 DSGVO)</li>
                    <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
                    <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
                    <li>Widerspruchsrecht (Art. 21 DSGVO)</li>
                </ul>
                <p className="text-sm text-gray-600 leading-relaxed">
                    Sie haben zudem das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer personenbezogenen Daten durch uns zu beschweren.
                </p>
            </section>

            <section className="space-y-2">
                <h3 className="text-lg font-semibold">7. SSL-Verschlüsselung</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                    Diese Website nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte eine SSL-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von „http://" auf „https://" wechselt.
                </p>
            </section>

            <p className="text-xs text-gray-400">Stand: Juni 2026</p>
        </div>
    );
}
